import { render, staticRenderFns } from "./serviceRanking.vue?vue&type=template&id=1dd6ec94&scoped=true"
import script from "./serviceRanking.vue?vue&type=script&lang=js"
export * from "./serviceRanking.vue?vue&type=script&lang=js"
import style0 from "./serviceRanking.vue?vue&type=style&index=0&id=1dd6ec94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd6ec94",
  null
  
)

export default component.exports